import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import SideContainer from '../SideContainer';
import Routers from '../../routes/Routers';
import { useAuth } from '../../context/AuthContext';
import ConditionalRender from '../../shared/components/ConditionalRender';
import AppHeader from './AppHeader';
import './AppLayout.scss';

const AppLayout: React.FC = () => {
  const location = useLocation();
  const { authenticated } = useAuth();
  const isPrintPage = location.pathname.includes('/print');

  // Print pages render bare, without the application chrome.
  if (isPrintPage) {
    return <Routers />;
  }

  return (
    <div className="app-shell">
      <AppHeader />

      <div className="app-shell__main">
        <ConditionalRender visible={authenticated}>
          <SideContainer />
        </ConditionalRender>
        <main className={clsx('app-shell__content', { 'app-shell__content--no-rail': !authenticated })}>
          <div className="app-shell__scroll">
            <Routers />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
